import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import style from './style.module.css';
import { useSellerHasBYOLOrderSource } from '../../hooks/use-seller-has-byol-order-source';
import { MessageDescriptorPropType } from '../../prop-types/intl';
import { linkIDs } from '../../services/link-service/links';
import { HelpArticleLink } from '../help-article-link';

export const BYOLRestrictionsBanner = ({ contentText }) => {
  const hasBYOL = useSellerHasBYOLOrderSource();

  return (
    !!hasBYOL && (
      <BannerMessageV2
        className={style['BYOL-warning']}
        content={
          <FormattedMessage
            {...contentText}
            values={{
              a: (chunks) => <HelpArticleLink articleId={linkIDs.MercadoLibreRestrictions}>{chunks}</HelpArticleLink>,
            }}
          />
        }
        status={BannerStatus.Info}
      />
    )
  );
};

BYOLRestrictionsBanner.propTypes = {
  contentText: MessageDescriptorPropType.isRequired,
};
